<template>
  <div class="body d-flex py-lg-3 py-md-2">
    <div class="container-xxl">
      <div class="row clearfix">
        <div class="col-md-12">
          <div class="card border-0 mb-2 no-bg">
            <div class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between main-button-area">
              <div class="header-section">
                <div class="search-area mt-2">
                 <!--  <input
                    id="main-search-input"
                    type="search"
                    class="form-control"
                    placeholder="Αναζήτηση..."
                    aria-label="search"
                    aria-describedby="addon-wrapping" v-model="search"  @input="updateFilters()"
                  /> -->
                </div>
              </div>
               <h3 class="text-center flex-grow-1 m-0 fw-bolder my-2"
    style="font-size: 1.8rem; letter-spacing: 1px; text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);">
    {{ listTitle }}
</h3>

              <div class="d-flex mt-sm-0 mt-3 justify-content-between">
                
                <button
                  type="button"
                  class="ms-0 ms-sm-3 btn btn-dark"
                  style="color:var(--secondary-color); font-weight:bold"
                  @click.prevent="submitForm"
                  v-if="canCreateList || superUser"
                >
                  Save list
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row clearfix g-1">
        <div class="col-lg-12">
          <div>
            <div class="card-body table-responsive">
             <TableNewList
  :columns="columns"
  :data="contactsData"
  :applyFilters="applyFilters"
  :paginationLinks="paginationLinks"
  :archiveContacts="archiveContacts"
  :tableOptions="tableOptions"
  :isLinkColumn="isLinkColumn"
  :sortBy="sortBy"
  :refreshTable="fetchList"   
  :count="totalCount"
  v-model:selectedIds="selectedIds"
/>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit List Modal -->
    <div
      class="modal fade"
      id="create-list-form"
      tabindex="-1"
      aria-labelledby="createprojectlLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold" id="createprojectlLabel">Στοιχεία λίστας</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="title" class="form-label">Title</label>
              <input
                type="text"
                class="form-control"
                id="title"
                v-model="listData.title"
                placeholder="Title"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="submitForm">Αποθήκευση</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import TableNewList from '@/components/TableNewList.vue';
import { useToast } from 'vue-toastification';
import { get, updateContacts } from '@/services/lists'; // your API methods
import { get as useFetchData } from '@/services/lists';
import { mapGetters } from 'vuex';
import { fetchAll } from "@/services/list-contacts"; 
import { watch } from 'vue';

const defaultListData = { title: '' };

export default {
  name: 'EditListPage',
  components: { TableNewList },
  computed: {
    ...mapGetters({
      getUserPermission: 'getUserPermission',
      getSuperUserPermission: 'getSuperUserPermission',
    }),
    superUser() {
      return this.getSuperUserPermission === 1;
    },
    userPermissions() {
      return this.getUserPermission('Lists');
    },
    canCreateList() {
      return this.userPermissions?.create === 1;
    },
  },
 setup() {
  const route = useRoute();
  const router = useRouter();
  const toast = useToast();
const selectedIds = ref([]);
  const search = ref('');
const currentSortBy = ref(null);
const currentSortDirection = ref('asc');


  // Refs για αποθήκευση δεδομένων
  const listData = ref({ ...defaultListData });
  const contactsData = ref([]);
  const totalCount = ref(0);
  const listTitle = ref('');
  const paginationLinks = ref([]);

  // Columns για τον πίνακα
  const columns = ref([
    { value: 'name', label: 'Name' },
    { value: 'clientNickname', label: 'Client Nickname' },
    { value: 'supplierNickname', label: 'Supplier Nickname' },
    { value: 'phone', label: 'TELEPHONE' },
    { value: 'email', label: 'EMAIL' },
    { value: 'address', label: 'ADDRESS' },
    { value: 'postal', label: 'POSTAL CODE' },
    { value: 'afm', label: 'AFM' },
  ]);

  // Query param για ID της λίστας
  const listId = computed(() => route.query.id);

  // 🔁 Φίλτρα
  const filters = ref({});

  const updateFilters = async (newFilters = {}) => {
  filters.value = { ...newFilters };

  try {
    const response = await fetchAll({
      params: {
        id: listId.value,
        ...filters.value,
        search: search.value,
        sortBy: currentSortBy.value,
        sortDirection: currentSortDirection.value,
        page: route.query.page || 1,
      }
    });

    const resData = response.data;

    if (resData?.success) {
      const contacts = resData.data?.data?.data || [];

      contactsData.value = contacts;
      totalCount.value = resData.data?.totalCount || contacts.length;
      paginationLinks.value = resData.data?.data?.pagination?.links || [];
    } else {
      toast.error(resData?.message || "Σφάλμα φόρτωσης δεδομένων.");
    }
  } catch (err) {
    toast.error("Αποτυχία φόρτωσης φίλτρων.");
  }
};



  // 🔁 Λήψη δεδομένων από API
  const fetchList = async () => {
    if (!listId.value) {
      toast.error('List ID missing in URL');
      return;
    }

    try {
      const response = await get({
        params: {
          id: listId.value,
          page: route.query.page || 1,
           search: search.value,
        sortBy: currentSortBy.value,
        sortDirection: currentSortDirection.value,
          ...filters.value // 🟡 εδώ εφαρμόζονται τα φίλτρα!
        },
      });

      const resData = response.data;

      if (resData?.success) {
        const list = resData.data;

        contactsData.value = list.contacts.data;
        totalCount.value = list.totalCount;
        listTitle.value = list.listName;
       paginationLinks.value = list.contacts.links;
        listData.value.title = list.listName || '';
      } else {
        toast.error(resData.message || 'Failed to load list data');
      }
    } catch (error) {
      console.error(error);
/*       toast.error('Error fetching list data');
 */    }
  };

  // Αποθήκευση λίστας
 const submitForm = async () => {
  if (!listId.value) {
    toast.error('List ID missing');
    return;
  }

  try {
    const response = await updateContacts(listId.value, {
      filter_data: { ...filters.value }, // ✅ όπως το ζητάς
      selected_contact_ids: selectedIds.value
    });

    if (response.data.success) {
      toast.success(response.data.message || 'Η λίστα ενημερώθηκε με επιτυχία');

     
      $("#create-list-form").modal('hide');


      router.push('/lists');
    } else {
      toast.error(response.data.message || 'Σφάλμα κατά την αποθήκευση');
    }
  } catch (error) {
    console.error(error);
    toast.error('Σφάλμα κατά την αποθήκευση λίστας');
  }
};


  // Πίνακας – βοηθητικά
  const isLinkColumn = (value) => value === 'name';


  const sortBy = (column) => {
  if (currentSortBy.value === column) {
    // Toggle direction
    currentSortDirection.value = currentSortDirection.value === 'asc' ? 'desc' : 'asc';
  } else {
    currentSortBy.value = column;
    currentSortDirection.value = 'asc';
  }

  fetchList();
};


  // 🟩 Η σημαντική συνάρτηση για TableNewList.vue
  const applyFilters = (newFilters) => {
    updateFilters(newFilters);
  };

  watch(() => route.query, () => {
    fetchList(); // refetch list when query params change
  });

  onMounted(() => {
    fetchList();
/*      updateFilters(); 
 */  });

  return {
    listData,
    contactsData,
    totalCount,
    paginationLinks,
    columns,
    filters,
    updateFilters,
    fetchList,
    submitForm,
    isLinkColumn,
    applyFilters,
   search,
  currentSortBy,
  currentSortDirection,
  sortBy,
    tableOptions: {
      path: 'edit-list',
      singlePagePath: 'contact',
    },
    listTitle,selectedIds,
  };
}

};
</script>

<style scoped>
.dropdown-menu.show {
    display: block;
}

tr.selected,
div.selected {
    background: #b1afaf;
}
</style>


